var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCornerRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_corner_rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_corner_rounded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_shape_rectangle_smooth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,0 C47.9553903,1.34328358 36.5799257,0.671641791 27.4349442,1.34328358 C19.8513011,1.79104478 13.605948,5.14925373 9.14498141,9.85074627 C1.56133829,17.9104478 0.892193309,30.4477612 0.669144981,40.5223881 C0.446096654,47.6865672 3.33066907e-15,53.9552239 0.223048327,54.4029851 L0.223048327,60 L1.56133829,60 L1.56133829,60 L58.8847584,60 C59.5539033,60 60,59.5522388 60,58.880597 C60,58.880597 60,58.880597 60,58.880597 L60,0 L58.66171,0 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,1.11940299 L58.66171,59.1044776 L1.33828996,59.1044776",
    id: "Path",
    stroke: "#BABABA",
    strokeWidth: 2.23048327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.60594821064889,7.070632140432591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7769517,2.23880597 C59.7769517,2.23880597 45.0557621,2.23880597 29.8884758,2.23880597 C17.1747212,2.46268657 2.4535316,14.5522388 2.4535316,30 C2.4535316,44.1044776 2.23048327,60 2.23048327,60 L0,60 C0,60 0,38.7313433 0,30 C0,14.1044776 13.3828996,0 29.6654275,0 C48.8475836,0 59.5539033,0 59.5539033,0 L59.7769517,2.23880597 Z",
    id: "Path",
    fill: "#505050",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCornerRounded);
export default __webpack_public_path__ + "static/media/icon-corner-rounded.85d3ccb3a7ce38f48010c55ca9636e9a.svg";
export { ForwardRef as ReactComponent };